import i18next from 'i18next';
import React from 'react';
import theme from '@theme';

import { Dropdown } from '@commons/utils/styledLibraryComponents';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import { Container, DropdownContainer, DropdownsContainer } from './styledComponents';

const DROPDOWN_LIST_MAX_HEIGHT = '200px';
const DROPDOWN_WIDTH = '250px';

const ExportRecipeByStoreModal = ({
  groups,
  selectedGroups,
  setSelectedGroups,
  stores,
  selectedStores,
  setSelectedStores,
}) => {
  const dropdownListStyle = { maxHeight: DROPDOWN_LIST_MAX_HEIGHT };

  return (
    <Container>
      <Text color={ENUM_COLORS.DARKER} font={ENUM_FONTS.TEXT_SMALL}>
        {i18next.t('ADMIN.RECIPES.EXPORT_BY_STORE_MODAL_INTRO')}
      </Text>
      <DropdownsContainer>
        {!!groups.length && (
          <DropdownContainer>
            <Dropdown
              customDropdownListStyle={dropdownListStyle}
              customStyle={{ position: 'inherit', width: DROPDOWN_WIDTH }}
              height={'68px'}
              iconSrc={'/images/inpulse/group-black-small.svg'}
              isUniqueSelection={false}
              items={groups}
              label={i18next.t('ADMIN.RECIPES.VARIANT_MODAL.GROUPS_LABEL')}
              labelStyle={{ font: theme.fonts.textSmall }}
              selectedItems={selectedGroups}
              onSelectionChange={setSelectedGroups}
            />
          </DropdownContainer>
        )}
        <DropdownContainer>
          <Dropdown
            customDropdownListStyle={dropdownListStyle}
            customStyle={{ position: 'inherit', width: DROPDOWN_WIDTH }}
            height={'68px'}
            iconSrc={'/images/inpulse/store-black-small.svg'}
            isUniqueSelection={false}
            items={stores}
            label={i18next.t('ADMIN.RECIPES.VARIANT_MODAL.STORES_LABEL')}
            labelStyle={{ font: theme.fonts.textSmall }}
            selectedItems={selectedStores}
            onSelectionChange={setSelectedStores}
          />
        </DropdownContainer>
      </DropdownsContainer>
    </Container>
  );
};

export default ExportRecipeByStoreModal;
